<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">
      Your 30-day free trial has ended.
    </h4>
  </div>
  <div class="modal-body">
    <p class="text-center">
      We hope you’re having a really
      great experience playing our games —
      and that you can feel yourself improving!
    </p>
    <p class="text-center">
      You can keep playing every game on the
      MuchSmarter platform for only @if (paymentService.isUk) {
      <span>£25</span>
      }@if (!paymentService.isUk) {
      <span>$30</span>
      }/month.
    </p>
    <p class="text-center">
      Do you wish to continue?
    </p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-block btn-primary text-capitalize" (click)="redirectToPayment(true)">Yes!</button>
    <button type="button" class="btn btn-block btn-primary mt-0 text-capitalize" (click)="redirectToPayment(false)">No thanks.</button>
  </div>
</ng-template>
